$(function(){
  var Cookies = require('js-cookie');
  
  $('.close-cookies').click(function(e){
    e.preventDefault();
    Cookies.set('cookies', 'hidden');
    $('.cookies-info').css('display', 'none');
  });

  var cookies = Cookies.get('cookies');
  if(cookies != 'hidden'){
    $('.cookies-info').css('display', '').removeClass('d-none');
  }else{
    $('.cookies-info').css('display', 'none');

  }
});

$('.cookies-info').on('click', function(e){
  var target  = $(e.target);
  if( target.is('a') ) {

  }else{
    Cookies.set('cookies', 'hidden');
    $('.cookies-info').css('display', 'none');
  }
});
